import React from 'react';
import Modal from "react-bootstrap/Modal";
import styles from "./modal.module.css";
import { ExclamationTriangle } from "react-bootstrap-icons";
import Button from '../molecules/Button';

type Props = {
    show: boolean;
    onHide: () => void;
    onOpen: (skipThisDialog: boolean, space: number) => void;
    space: number;
}

export const ConfirmOpenHexagonModal = ({show, onHide, onOpen, space}: Props) => {

    const [skipDialog, setSkipDialog] = React.useState<boolean>(false);

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Body className={styles.background}>
                <div className="m-5">
                    <div className="text-center mb-3">
                        <ExclamationTriangle size={"100"} color="#dde336"/>
                    </div>
                    <h4 className="text-center fs-5 mb-4">This will return the artworks on this wall to your artworks repository.</h4>
                    <div className='my-1'>
                        <input className='mx-2' id='skip' type='checkbox' checked={skipDialog} onChange={e => setSkipDialog(e.target.checked)}/>
                        <label htmlFor='skip'>Don't show this again</label>
                    </div>
                    <div className="d-flex justify-content-center mt-4">
                        <Button small className='me-4 btn btn-success' onClick={onHide}>
                            Cancel
                        </Button>
                        <Button small className='btn btn-success' onClick={() => onOpen(skipDialog, space)}>
                            Continue
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}